<div class="filter-bar">
    <div class="control control--input control--search">
        <input type="text" class="search" [placeholder]="placeholder" [value]="textSearch" #q
            (input)="onInput(q.value)" />
        <button class="search-action" type="button" aria-label="Buscar" title="Buscar" (click)="onSearchClick()">
            <iconify-icon icon="mdi:magnify" width="20" height="20"></iconify-icon>
        </button>
    </div>

    <div class="control control--select" [class.open]="isOpen" (click)="toggle(); $event.stopPropagation()">
        <span class="label"><span *ngIf="dropdownLabel" class="label__prefix">{{ dropdownLabel }}:</span> {{ currentLabel }}</span>
        <iconify-icon icon="mdi:chevron-down" width="20" height="20" class="caret-icon"></iconify-icon>

        <div class="menu" *ngIf="isOpen" (click)="$event.stopPropagation()">
            <button *ngFor="let opt of dropdownOptions" class="menu-item" [class.active]="opt.value === dropdownValue"
                (click)="select(opt); $event.stopPropagation()">
                {{ opt.label }}
            </button>
        </div>
    </div>

    <div *ngIf="dropdown2Options.length" class="control control--select" [class.open]="isOpen2"
        (click)="toggle2(); $event.stopPropagation()">
        <span class="label"><span *ngIf="dropdown2Label" class="label__prefix">{{ dropdown2Label }}:</span> {{ currentLabel2 }}</span>
        <iconify-icon icon="mdi:chevron-down" width="20" height="20" class="caret-icon"></iconify-icon>

        <div class="menu" *ngIf="isOpen2" (click)="$event.stopPropagation()">
            <button *ngFor="let opt of dropdown2Options" class="menu-item" [class.active]="opt.value === dropdown2Value"
                (click)="select2(opt); $event.stopPropagation()">
                {{ opt.label }}
            </button>
        </div>
    </div>
</div>
